import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { Box, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const Scrollbar = ({ className, children, ...rest }) => {
  const theme = useTheme();
  const thumbColor = alpha(theme.palette.primary.main, 0.34);
  const thumbHoverColor = alpha(theme.palette.primary.main, 0.58);
  const trackColor = alpha(theme.palette.common.black, theme.palette.mode === 'dark' ? 0.2 : 0.05);

  const renderThumb = (axis) => (
    <Box
      sx={{
        width: axis === 'vertical' ? 7 : '100%',
        height: axis === 'horizontal' ? 7 : '100%',
        borderRadius: 999,
        background: thumbColor,
        boxShadow: `inset 0 0 0 1px ${alpha(theme.palette.common.white, 0.42)}`,
        transition: theme.transitions.create(['background-color', 'box-shadow'], {
          duration: theme.transitions.duration.shorter
        }),

        '&:hover': {
          background: thumbHoverColor,
          boxShadow: `inset 0 0 0 1px ${alpha(theme.palette.common.white, 0.72)}`
        }
      }}
    />
  );

  const renderTrackVertical = ({ style, ...props }) => (
    <Box
      {...props}
      style={{
        ...style,
        top: 8,
        bottom: 8,
        right: 4,
        width: 8
      }}
      sx={{
        borderRadius: 999,
        background: trackColor
      }}
    />
  );

  const renderTrackHorizontal = ({ style, ...props }) => (
    <Box
      {...props}
      style={{
        ...style,
        left: 8,
        right: 8,
        bottom: 4,
        height: 8
      }}
      sx={{
        borderRadius: 999,
        background: trackColor
      }}
    />
  );

  return (
    <Scrollbars
      autoHide
      autoHideTimeout={600}
      autoHideDuration={180}
      universal
      renderTrackVertical={renderTrackVertical}
      renderTrackHorizontal={renderTrackHorizontal}
      renderThumbVertical={() => renderThumb('vertical')}
      renderThumbHorizontal={() => renderThumb('horizontal')}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

Scrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Scrollbar;
